// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__xKZ5A","errorLogs":"EditorFooter_errorLogs__7rfSP"};